<ng-container *transloco="let t">
  <label>
                              <span class="fw-bold">
                              <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng"
                                                   [itLabel]="race?.nameIta"
                                                   [siLabel]="race?.nameSlo"
                                                   [defaultLanguage]="defaultLanguage" [languages]="languages"/>,
                                 </span>
    {{
      (race?.registrationType === RegistrationType.RACE && race?.length && (race?.length ?? 0) > 0) ?
        " - " + (race?.length | raceLengthFormat:translocoService.getActiveLang())
        : ''
    }}
    @if (registerToRaceFormType === RegisterToRaceFormType.PAYMENT) {
      {{
        " - " + getRaceCommercialItemPrice(competitorRegistrationSummaryItem?.raceCommercialItem)
      }}
    } @else {
      {{
        (raceCommercialItems.length === 1) ? " - " + getRaceCommercialItemPrice(
          raceCommercialItems[0])
          :
          " - " + getRaceCommercialItemPrice(competitorRegistrationSummaryItem?.raceCommercialItem)
      }}
    }
  </label>
</ng-container>
